import raf from 'raf';
import getOffset from './getOffset';
import getScrollTop from './getScrollTop'; // Ease in out function.
// Borrowed from http://bit.ly/2ibTTGm.

function easeInOutCubic(t) {
  return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
} // Calculates the scroll position we should be in given the start and
// end point of the scroll the time elapsed from the beginning of the
// scroll and the total duration of the scroll.


function position(start, end, elapsed, duration) {
  if (elapsed > duration) return end;
  return start + (end - start) * easeInOutCubic(elapsed / duration);
}

/**
 * Smooth scrolls to the specified element or location.
 * @param target If target is an element then scrolls to the top of this
 * element. Otherwise, if target is numeric then scrolls to that
 * location.
 * @param duration Total duration for scroll animation.
 * @param callback If specified, it is called when the scrolling
 * is finished.
 */
export default function smoothScroll(target) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  var callback = arguments.length > 2 ? arguments[2] : undefined;
  var startY = getScrollTop(window);
  var endY;

  if (typeof target === 'string') {
    endY = parseInt(target, 10);
  } else if (typeof target === 'number') {
    endY = target;
  } else {
    endY = getOffset(target).top;
  }

  var startTime = Date.now();

  var step = function step() {
    var elapsedTime = Date.now() - startTime;
    window.scroll(0, position(startY, endY, elapsedTime, duration));

    if (elapsedTime > duration) {
      if (typeof callback === 'function') {
        callback(target);
      }
    } else {
      raf(step);
    }
  };

  step();
}
//# sourceMappingURL=smoothScroll.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/blaze-consumer/~/@flowio/browser-helpers/lib/esm/smoothScroll.js
// module id = 493
// module chunks = 0 1